import { getRoutes } from '@ui-framework/index';
import IssuesList from './pages/list';
import IssueDetailPage from './pages/detail';
import schema from './schemas/routes.json';
import ErrorPage, { ERROR_PAGE_TYPE } from '../ErrorPage';
import IssueFormStore from './store';
import IssueListStore from './store/list';

const Pages = ProtectedRoute => ({
  IssuesList: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={IssuesList}
    />
  ),
  IssueDetailPage: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={IssueDetailPage}
    />
  ),
});

const routes = ({ ProtectedRoute, BubbleRouteError }) =>
  getRoutes({
    schema,
    ProtectedRoute,
    BubbleRouteError,
    Pages: Pages(ProtectedRoute),
  });

const stores = rootStore => [
  {
    issueFormStore: new IssueFormStore(rootStore),
    issueListStore: new IssueListStore(rootStore),
  },
];

export { IssuesList, IssueDetailPage, routes, stores };
